module.exports = __webpack_public_path__ + "static/media/maleCasualCool.3794b6aa.png";